<template>
	<v-dialog
		v-model="showDialog"
		max-width="800px"
		@click:outside="closeDialog()"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs" min-height="580px" class="pb-3">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">発注メール送信</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-form class="pa-2" ref="form">
				<v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-combobox
							type="text"
							v-model="emails"
							:rules="[rules.required]"
							label="TO"
							dense
							outlined
							hide-details="false"
							:class="{
								'mr-2': !$vuetify.breakpoint.xs,
							}"
							multiple
							small-chips
						/>
					</v-col>
					<v-col cols="12" sm="6">
						<v-combobox
							type="text"
							v-model="cc_emails"
							label="CC"
							:class="$vuetify.breakpoint.xs ? 'mt-4' : ''"
							dense
							outlined
							hide-details="false"
							multiple
							small-chips
						/>
					</v-col>
				</v-row>
				<v-text-field
					type="text"
					label="メールタイトル(必須)"
					class="mt-4"
					:rules="[rules.required]"
					dense
					v-model="mailInfo.title"
					outlined
					hide-details="auto"
				/>
				<v-textarea
					label="メール文章(必須)"
					class="mt-2 mb-4"
					:rules="[rules.required]"
					outlined
					v-model="mailInfo.content"
					dense
					hide-details="auto"
				/>
				<DragUpload @fileShare="fileShare" />
			</v-form>
			<div class="ma-5 text-body-2">
				注文書を送付する際は、注文書ページの右上にある『印刷』ボタンをクリックし、PDFファイルとして保存してください。保存後は、注文書を添付する欄にファイルをアップロードしてください。<br />
				また、事前に注文フォームでアップロードされたファイルはメール本文と一緒に送信されます。
			</div>

			<v-row justify="center" no-gutters>
				<v-btn class="mt-4 mr-4" color="secondary" dark @click="sendMail()">メールを送信</v-btn>
				<v-btn class="mt-4 ml-4" @click="closeDialog()">キャンセル</v-btn>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import DragUpload from "../../shared/DragUpload.vue"
import moment from "moment"
import "moment/locale/ja"

export default {
	components: {
		DragUpload,
	},
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		orderDataComponents: {
			type: Array,
		},
		currentUser: {
			type: Object,
		},
		supplier: {
			type: Object,
		},
		orderDataId: {
			type: Number,
		},
		orderData: {
			type: Object,
		},
		supplierEmails: {
			type: Array,
		},
		ccEmails: {
			type: Array,
		},
	},
	data() {
		return {
			confirmation: "",
			rules,
			uploadFiles: [],
			mailInfo: {
				title: "",
				content: "",
			},
			text: [],
			fileNames: [],
			emails: [],
			cc_emails: [],
		}
	},

	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月DD日(dd)")
		},
	},

	mounted() {
		this.setMailTitle()
		this.emails = this.supplierEmails
		this.emails.push(this.supplier.email)
		this.cc_emails = this.ccEmails
		this.cc_emails.push(this.currentUser.email)
	},

	methods: {
		fileShare(files) {
			this.uploadFiles = files
		},
		closeDialog() {
			this.showDialog = false
		},

		sendMail() {
			const order_data_id = this.orderDataId
			if (this.uploadFiles.length > 0) {
				this.uploadFiles.forEach((file) => {
					this.fileUpload(file, order_data_id)
				})
			} else {
				this.fileUpload("", order_data_id)
			}
			this.$router.push({ name: "order_data" })
		},

		fileUpload(file, order_data_id) {
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()

			formData.append("supplier_emails", JSON.stringify(this.emails))
			formData.append("cc_emails", JSON.stringify(this.cc_emails))
			formData.append("order_data_id", order_data_id)
			formData.append("order_component_id", this.orderComponentId)
			formData.append("mail_flag", true)
			formData.append("mail_infos[content]", this.mailInfo.content)
			formData.append("mail_infos[title]", this.mailInfo.title)
			formData.append("file", file)
			axios
				.post("/erp/v1/order_data/files", formData, { headers })
				.then((res) => {
					if (!res.data.no_error) {
						this.$store.dispatch("setFlash", {
							text: res.data.miss_file + "の作成に失敗しました",
							type: "alert",
						})
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		setContent() {
			if (this.supplier.email && this.orderData.order_number.endsWith("-1")) {
				const old_number = this.orderData.order_number.slice(0, -2)
				let orderDetails = ""

				for (const orderDataComponent of this.orderDataComponents) {
					orderDetails += `部品名: ${orderDataComponent.component_name}\n`
					orderDetails += `発注単価: ${orderDataComponent.unit_price}\n`
					orderDetails += `発注個数: ${orderDataComponent.quantity}\n`
					orderDetails += `仕様: ${orderDataComponent.remarks}\n`
					orderDetails += `納期: ${this.formatDate(orderDataComponent.expected_receiving_date)}\n`
					orderDetails += "\n"
				}
				this.mailInfo.content = `${this.supplier.name}\n${this.supplier.pic_name}様\nいつもお世話になっております。\n極東ゴムの${this.currentUser.last_name}です。\n注文書番号${old_number}の修正分となります。\n以下の条件にて、発注をお願いしたくご連絡申し上げます。\n\n【発注詳細】\n${orderDetails}以上、何卒よろしくお願いいたします。\n極東ゴム株式会社\n${this.currentUser.full_name}`
			} else if (this.supplier.email && this.orderData.order_number.match(/-\d+$/)) {
				let orderDetails = ""
				const updated_order_number = this.orderData.order_number
				const old_number = updated_order_number.replace(
					/-(\d+)$/,
					(_, num) => `-${Number(num) - 1}`
				)

				for (const orderDataComponent of this.orderDataComponents) {
					orderDetails += `部品名: ${orderDataComponent.component_name}\n`
					orderDetails += `発注単価: ${orderDataComponent.unit_price}\n`
					orderDetails += `発注個数: ${orderDataComponent.quantity}\n`
					orderDetails += `仕様: ${orderDataComponent.remarks}\n`
					orderDetails += `納期: ${this.formatDate(orderDataComponent.expected_receiving_date)}\n`
					orderDetails += "\n"
				}
				this.mailInfo.content = `${this.supplier.name}\n${this.supplier.pic_name}様\nいつもお世話になっております。\n極東ゴムの${this.currentUser.last_name}です。\n注文書番号${old_number}の修正分となります。\n以下の条件にて、発注をお願いしたくご連絡申し上げます。\n\n【発注詳細】\n${orderDetails}以上、何卒よろしくお願いいたします。\n極東ゴム株式会社\n${this.currentUser.full_name}`
			} else if (this.supplier.email && !this.orderData.order_number.match(/-\d+$/)) {
				let orderDetails = ""
				for (const orderDataComponent of this.orderDataComponents) {
					orderDetails += `部品名: ${orderDataComponent.component_name}\n`
					orderDetails += `発注単価: ${orderDataComponent.unit_price}\n`
					orderDetails += `発注個数: ${orderDataComponent.quantity}\n`
					orderDetails += `仕様: ${orderDataComponent.remarks}\n`
					orderDetails += `納期: ${this.formatDate(orderDataComponent.expected_receiving_date)}\n`
					orderDetails += "\n"
				}
				this.mailInfo.content = `${this.supplier.name}\n${this.supplier.pic_name}様\nいつもお世話になっております。\n極東ゴムの${this.currentUser.last_name}です。\n以下の条件にて、発注をお願いしたくご連絡申し上げます。\n\n【発注詳細】\n${orderDetails}以上、何卒よろしくお願いいたします。\n極東ゴム株式会社\n${this.currentUser.full_name}`
			} else {
				this.text.push("メールアドレスが登録されていません")
				this.mailInfo.content = this.text.join("")
			}
		},
		setMailTitle() {
			const date = moment(Date.now())
			let title
			if (this.orderData.order_number.match(/-\d+$/)) {
				// 末尾に-1や-2などがついている場合
				title = `部品の発注につきまして(${this.formatDate(date)})` + "(再送付)"
			} else {
				// 末尾に何もついていない場合
				title = `部品の発注につきまして(${this.formatDate(date)})`
			}
			this.mailInfo.title = title
			this.setContent()
		},
		formatDate(date) {
			if (!date) return ""
			return moment(date).format("YYYY年MM月DD日")
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>

<style scoped lang="scss">
.v-card {
	overflow-x: hidden;
}
</style>
